import { render, staticRenderFns } from "./ImpactStandardization.vue?vue&type=template&id=a11ebece&"
import script from "./ImpactStandardization.vue?vue&type=script&lang=js&"
export * from "./ImpactStandardization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports